import { render, staticRenderFns } from "./lkLayout.vue?vue&type=template&id=77087f5e&scoped=true&"
import script from "./lkLayout.vue?vue&type=script&lang=js&"
export * from "./lkLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77087f5e",
  null
  
)

export default component.exports